import { constructNow } from "./constructNow.js";
/**
 * The {@link startOfYesterday} function options.
 */

/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @typeParam ContextDate - The `Date` type of the context function.
 *
 * @param options - An object with options
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */

export function startOfYesterday(options) {
  var now = constructNow(options === null || options === void 0 ? void 0 : options.in);
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = constructNow(options === null || options === void 0 ? void 0 : options.in);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
} // Fallback for modularized imports:

export default startOfYesterday;